import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.2) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function EmpathySection() {
  const {
    ref,
    inView
  } = useInView();
  return <section className="section-cream py-20 lg:py-28" ref={ref} data-id="element-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-25">
        {/* Opening quote */}
        <div className="transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-26">
          <div className="relative p-8 lg:p-12 rounded-2xl mb-12" style={{
          backgroundColor: '#FAF7F2',
          border: '1px solid #E0D8C8',
          boxShadow: '0 4px 40px rgba(27,58,92,0.08)'
        }} data-id="element-27">
            <div className="absolute -top-5 left-8 font-heading text-7xl leading-none" style={{
            color: '#C9A84C',
            opacity: 0.4
          }} data-id="element-28">
              "
            </div>
            <p className="font-heading italic text-xl lg:text-2xl leading-relaxed" style={{
            color: '#1B3A5C'
          }} data-id="element-29">
              Gracias por tu interés, pero hemos decidido avanzar con perfiles
              que se ajustan más a...
            </p>
            <div className="absolute -bottom-3 right-8 font-heading text-7xl leading-none" style={{
            color: '#C9A84C',
            opacity: 0.4
          }} data-id="element-30">
              "
            </div>
          </div>
        </div>

        {/* Body copy */}
        <div className="space-y-6 transition-all duration-700 delay-200" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-31">
          <p className="font-body text-lg lg:text-xl leading-relaxed" style={{
          color: '#2A3A4A'
        }} data-id="element-32">
            Miraste la pantalla. <strong data-id="element-33">Otra vez ese maldito mensaje.</strong>
          </p>
          <p className="font-body text-lg leading-relaxed" style={{
          color: '#3A4A5A'
        }} data-id="element-34">
            Sabes perfectamente lo que significa. Es el código para decirte que
            tu fecha de nacimiento les asusta. Que creen que por tener más de 45
            años, no entiendes este nuevo mundo. Que eres demasiado{' '}
            <em data-id="element-35">"cara"</em> o demasiado <em data-id="element-36">"lenta"</em>.
          </p>
          <p className="font-heading italic text-xl font-bold" style={{
          color: '#1B3A5C'
        }} data-id="element-37">
            Se equivocan. Pero pelear contra ellos es perder el tiempo.
          </p>
        </div>

        {/* Gold divider */}
        <div className="my-10 gold-divider" data-id="element-38" />

        {/* Callout box */}
        <div className="p-8 rounded-2xl transition-all duration-700 delay-400" style={{
        backgroundColor: '#1B3A5C',
        border: '2px solid #C9A84C',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-39">
          <p className="font-heading text-xl lg:text-2xl font-bold text-center leading-relaxed" style={{
          color: '#FAF7F2'
        }} data-id="element-40">
            El mercado laboral en España está{' '}
            <span style={{
            color: '#C9A84C'
          }} data-id="element-41">
              roto para nosotras
            </span>
            .
          </p>
          <p className="font-body text-center mt-3" style={{
          color: '#C8D8E8'
        }} data-id="element-42">
            Pero hay otro mercado que te está esperando. Uno donde tu
            experiencia es oro.
          </p>
        </div>
      </div>
    </section>;
}